import React from "react";
import Logo from "./svg/Logo.js";
import { animatedLogo } from "./svg/Logo.css.js";

const Spinner: React.FC = () => <Logo className={animatedLogo} />;

export default Spinner;
